import { render, staticRenderFns } from "./CompositeAlarmRuleTable.vue?vue&type=template&id=534c69ce&scoped=true"
import script from "./CompositeAlarmRuleTable.vue?vue&type=script&lang=js"
export * from "./CompositeAlarmRuleTable.vue?vue&type=script&lang=js"
import style0 from "./CompositeAlarmRuleTable.vue?vue&type=style&index=0&id=534c69ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c69ce",
  null
  
)

export default component.exports